import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";


const Myfund = () => {

  const [userBasic, setuserBasic] = useState([]);

  const getuserBasic = async () => {
    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/pingeneration/pin-request/all"
      );
      setuserBasic(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const [pendingRequest, setpendingRequest] = useState([]);

  useEffect(() => {
    const fetchRequest = async () => {
      try {
        const response = await axios.get(`https://apimlm.bloomitsolutions.in/pingeneration//pin-request/all`);
        setpendingRequest(response.data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchRequest();
  }, []);

  // Filter active users and get the latest 5 records
  const Pending = pendingRequest
    .filter(user => user.status === "Pending")


  useEffect(() => {
    getuserBasic();
   
  }, []);


  return (
    <section>
      <div className="container-fluid">
        <div className="row">

        
            
          <div className="col-lg-8 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>Fund Request details</h4>
              </div>

              <div className="card-body text-center">
                <div className="col-lg-10 ">
                  <div className="row ">

                    {/* =======================basic start================= */}

                    <div className="col-lg-4 border border-3 bg bg-warning rounded-3 text-center mt-3">
                      <h5 className="mt-2">Pin Status</h5>
                      <h2 className="mt-2">
                        <i className="fa fa-eye" aria-hidden="true"></i>{userBasic.length}
                      </h2>

                      <Link
                        to="/PinStatus"
                        className="btn btn-danger btn-sm mt-2 mb-2"
                      >
                        Click here
                      </Link>

                    </div>

                    {/* =======================basic end================= */}

                    {/* ====================Premium start==================== */}


                    <div className="col-lg-4 border border-3 bg bg-info rounded-3 text-center mt-3">
                      <h5 className="mt-2">Pin Request</h5>
                      <h2 className="mt-2">
                        <i className="fa fa-eye" aria-hidden="true"></i> {Pending.length}
                      </h2>

                      <Link
                        to="/pin-request"
                        className="btn btn-danger btn-sm mt-2 mb-2"
                      >
                        Click here
                      </Link>

                    </div>

                    {/* ====================Premium end==================== */}


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Myfund;
